module.exports = __webpack_public_path__ + "img/468.1e4ea813.jpg";